export default __webpack_public_path__ + "static/media/pic10.2cb7a69a.jpg";